import { render, staticRenderFns } from "./PriceDetails.vue?vue&type=template&id=2594edd4&scoped=true&"
import script from "./PriceDetails.vue?vue&type=script&lang=ts&"
export * from "./PriceDetails.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PriceDetails.vue?vue&type=style&index=1&id=2594edd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2594edd4",
  null
  
)

export default component.exports